import Image from 'next/image';
import { CSSProperties } from 'react';

interface ThreeBarLoaderProps {
  style?: CSSProperties;
  alignTop?: boolean;
}

export default function ThreeBarLoader({ style = undefined, alignTop = undefined }: ThreeBarLoaderProps) {
  return (
    <div id="shared__div__three-bar_loader_0" className={`q-loader ${alignTop ? 'alignTop' : ''}`} style={style}>
      <Image
        className={`q-loader-spinner ${alignTop ? 'alignTop' : ''}`}
        src="/Quattr_spinner_transparent.gif"
        alt="loader"
        width={40}
        height={40}
        unoptimized
      />
    </div>
  );
}
